import UploadImgBox from './UploadImgBox.vue'
import ImageLook from './ImageLook.vue'
import LoginBox from './LoginBox.vue'
import UserComment from './UserComment.vue'
import RichText from './RichText.vue'
import PdfReview from './PdfReview.vue'

const zkUI = {
  install: function (Vue) {
    Vue.component('UploadImgBox', UploadImgBox)
    Vue.component('ImageLook', ImageLook)
    Vue.component('LoginBox', LoginBox)
    Vue.component('UserComment', UserComment)
    Vue.component('RichText', RichText)
    Vue.component('PdfReview', PdfReview)
  }
}

// 导出组件
export default zkUI
